var render = function (_h,_vm) {var _c=_vm._c;return _c('footer',[_c('a',{attrs:{"target":"_blank","href":"https://ukit.com/","rel":"noopener"}},[_vm._v("uKit")]),_vm._v(",\n  "+_vm._s(new Date().getFullYear())+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }